import { useCallback, useState } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';
import type { WaypointCallbackArgs } from '#src/app/shared/components/layout/lazy';

export const VIEW_TRACKING_EVENT = 'petition_manage_share_petition_online_view';

type UseTrackSharePetitionOnlineViewResult = ModelHookResult<
	undefined,
	{
		trackView: (args: WaypointCallbackArgs) => void;
	}
>;

export function useTrackSharePetitionOnlineView(): UseTrackSharePetitionOnlineViewResult {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const [tracked, setTracked] = useState(false);
	const track = useTracking();

	const trackView = useCallback(
		({ currentPosition }: WaypointCallbackArgs) => {
			if (tracked || currentPosition === 'below') {
				return;
			}

			void track(VIEW_TRACKING_EVENT, {
				petition_id: `petition_${petition.id}`,
				source_location: 'petition_dashboard_share_online',
				view_context: 'petition_dashboard_share_online',
			});
			setTracked(true);
		},
		[tracked, track, setTracked, petition.id],
	);

	return {
		actions: {
			trackView,
		},
	};
}
